/**
 * Client-side email validation for waitlist (subset of RFC 5322, UX-focused).
 * @param {string} raw
 * @returns {boolean}
 */
export function isValidWaitlistEmail(raw) {
  const s = String(raw ?? "").trim();
  if (!s || s.length > 254) {
    return false;
  }
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!re.test(s)) {
    return false;
  }
  const [local, domain] = s.split("@");
  return local.length <= 64 && domain.length <= 253 && !domain.startsWith(".") && !domain.endsWith(".");
}
